/* globals BS */

import DailySchedule from './DailySchedule'
import getNewDailySchedule from './getNewDailySchedule'

export default {
	name: 'ScheduleMatomete',
	props: {
	},
	data: function () {
		var index = 0
		return {
			days: ['月', '火', '水', '木', '金', '土', '日'].map(function (day) {
				return { index: index++, name: day, isActive: false }
			}),
			schedule: {
				id: '--',
				divs: getNewDailySchedule()
			},
			isToggling: false,
			eventType: null, // 先に発生したイベントのみ受け付ける
			togglingState: false,
			prevTarget: null
		}
	},
	methods: {
		toggleStart: function (eventType, event, day) {
			event.preventDefault()
			if (this.isToggling) {
				return
			}
			this.isToggling = true
			this.eventType = eventType
			this.togglingState = !day.isActive
			this.prevTarget = null
			day.isActive = !day.isActive
		},
		toggleMove: function (eventType, event) {
			if (!this.isToggling || this.eventType !== eventType) {
				return
			}
			event.preventDefault()

			const targetE = BS.event.touchmoveTarget(event)
			if (!targetE) {
				this.isToggling = false
				return
			}
			const dayE = BS.DOM.closest('.ds-col-day', targetE)
			if (!dayE || this.prevTarget === dayE) {
				return
			}
			this.prevTarget = dayE
			this.days[dayE.getAttribute('data-index')].isActive = this.togglingState
		},
		toggleStop: function () {
			this.isToggling = false
		}
	},
	computed: {
		daysAndDivsSelected: function () {
			if (!this.days.some(function (day) { return day.isActive })) {
				return false
			}
			if (!this.schedule.divs.some(function (div) { return div.isActive })) {
				return false
			}
			return true
		}
	},
	components: {
		DailySchedule
	},
	template: `
	<transition>
		<div class="ds-matomete-wrap"
			@mousemove="toggleMove('mouse', $event)"
			@touchmove="toggleMove('touch', $event)"
			@mouseup="toggleStop"
			@mouseleave="toggleStop"
			@touchend="toggleStop">
			<div class="ds-matomete-backdrop"></div>
			<div class="ds-matomete-container">
				<div class="ds-matomete card px-2 py-2">
					<h5 class="mt-1">まとめて登録</h5>
					<h6 class="mb-2">曜日を選択</h6>
					<div class="ds-row ds-row-body">
						<span v-for="day in days"
							:data-index="day.index"
							class="ds-col ds-col-day selectable" :class="{'can-work': day.isActive}"
							@mousedown="toggleStart('mouse', $event, day)"
							@touchstart="toggleStart('touch', $event, day)">
							{{day.name}}</span>
					</div>
					<p class="small text-muted">選択した曜日の予定は上書きされます。</p>

					<h6 class="mt-3 mb-2">時間を選択</h6>
					<DailySchedule
						:day="schedule"
						:matometeEditable="true"
					/>
					<p class="ds-matomete-footer">
						<button type="button" class="btn btn-primary"
							:disabled="!daysAndDivsSelected"
							@click="$emit('apply', {days: days, divs: schedule.divs})">
							登録する
						</button>
						<button type="button" class="btn btn-default"
							@click="$emit('cancel')">
							キャンセル
						</button>
					</p>
				</div>
			</div>
		</div>
	</transition>
	`
}
